import { render, staticRenderFns } from "./Capsule.vue?vue&type=template&id=0434a0ff&"
import script from "./Capsule.vue?vue&type=script&lang=js&"
export * from "./Capsule.vue?vue&type=script&lang=js&"
import style0 from "./Capsule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports